module.exports = __webpack_public_path__ + "static/media/POS_01_A.1b48f816.png";